import React, { useMemo } from 'react'
import { View } from 'react-native'
import { useBaseLayoutStyle } from '../../ions/styles'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

/**
 * @param props
 * @param { boolean } props.minified - flex unset
 * @param { boolean } props.center - centers content
 * @param { boolean } props.row - row flex direction
 * @returns {JSX.Element}
 * @constructor
 */
export const Container = React.memo((props: any) => {
  const { style, minified, center, row = false, ...rest } = props
  const { container, containerCentered, minimized } = useBaseLayoutStyle()
  const composedStyle = useMemo(
    () =>
      composeStyle(
        container,
        style,
        center ? containerCentered : {},
        minified ? minimized : {},
        row && { flexDirection: 'row' },
      ),
    [container, style, center, containerCentered, minified, minimized, row],
  )
  return <View {...rest} style={composedStyle} />
})
